import { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import api, { formatINR } from "@/lib/api";
import { useNavigate } from "react-router-dom";

const KPIS = [
  ["leads", "Leads"],
  ["approved", "Approved"],
  ["rejected", "Rejected"],
  ["disbursed", "Disbursed"],
  ["pending_documents", "Pending docs"],
];

export default function DealerDashboard() {
  const [m, setM] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    api.get("/dashboard/dealer").then(r => setM(r.data));
  }, []);
  return (
    <div data-testid="dealer-dashboard">
      <div className="flex justify-between items-start mb-6">
        <div>
          <h1 className="text-2xl font-semibold text-slate-900">Dealer Dashboard</h1>
          <p className="text-sm text-slate-600 mt-1">Manage your customer leads and approvals.</p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={() => navigate("/dealer/applications")} data-testid="dealer-view-apps-btn">View applications</Button>
          <Button className="bg-teal-600 hover:bg-teal-700" onClick={() => navigate("/dealer/new")} data-testid="dealer-new-lead-btn">Create lead</Button>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        {KPIS.map(([k, label]) => (
          <Card key={k} className="p-5 border-slate-200" data-testid={`dealer-kpi-${k}`}>
            <div className="text-xs uppercase tracking-wider text-slate-500">{label}</div>
            <div className="text-3xl font-semibold text-slate-900 mt-1 font-mono">{m?.[k] ?? "—"}</div>
          </Card>
        ))}
      </div>
    </div>
  );
}
